// filepath: apps/web/src/features/admin/templates/update/ApplyUpdateButton.tsx
//
// FR-UI-ADM-12 AC-5 / AC-7 — Apply Update button. Disabled
// (with aria-disabled=true and a tooltip) until every conflict
// has a resolution. The visible label shows the
// "X of Y resolved" counter (the same counter the page-level
// banner shows).

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

interface ApplyUpdateButtonProps {
  disabled: boolean;
  pending: boolean;
  resolvedCount: number;
  totalConflicts: number;
  onClick: () => void;
}

export function ApplyUpdateButton({
  disabled,
  pending,
  resolvedCount,
  totalConflicts,
  onClick,
}: ApplyUpdateButtonProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className="rounded bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-50"
      aria-disabled={disabled}
      title={
        disabled
          ? t("admin.templates.update.apply.disabled_tooltip")
          : undefined
      }
      data-testid="template-update-apply-button"
    >
      {pending
        ? "…"
        : `${t("admin.templates.update.apply")} (${resolvedCount}/${totalConflicts})`}
    </button>
  );
}
